<template>
  <div style="min-width: 10rem;">
    <template v-if="isReseller">
      <div class="d-flex align-center text-body-2">
        <v-icon size="18" class="mr-1" color="#586CDA">mdi-account-tie</v-icon>
        <span>Reseller: {{ resellerName }}</span>
      </div>
    </template>
    <template v-else>
      <v-select
        v-model="selectedCid"
        @update:modelValue="changeCompanyId"
        :items="cidList"
        item-title="name"
        item-value="value"
        variant="outlined"
        density="compact"
        hide-details
      ></v-select>
    </template>
  </div>
</template>

<script>
import imanager3Appframe from "@/scripts/imanager3-appframe"
import iStoreUtils from "@/scripts/istore-utils.js"

export default {
  name: "AppHeaderDropdownCid",
  data() {
    return {
      selectedCid: this.$store.state.loginUser.cid,
      cidList: [],
      isReseller: false,
      resellerName: this.$store.state.loginUser.userName || ""
    }
  },
  created() {
    this.isReseller = (this.$store.state.loginUser.roles || []).some(r => r.name === 'orion_reseller')
    const rawCids = Array.isArray(this.$store.state.loginUser.cids) ? this.$store.state.loginUser.cids.filter(Boolean) : []
    const fallback = [this.$store.state.loginUser.cid, this.$store.state.loginUser.starNumber, this.$store.state.loginUser.userId].filter(Boolean)
    const cidValues = rawCids.length ? rawCids : fallback

    this.cidList = cidValues.map((cid) => {
      return {
        name: `CID: ${cid}`,
        value: cid
      }
    })

    if (!this.selectedCid && cidValues.length) {
      this.selectedCid = cidValues[0]
    }
  },
  methods: {
    changeCompanyId() {
      const change_to = this.selectedCid
      if (!change_to) return
      this.sendTrackingAction(
        this.$store.state.loginUser.userId,
        "Changed CID",
        {
          "page": "AppHeader",
          "data": {
            "currentCid": change_to
          }
        }
      )
      this.$store.commit('setCompanyIds', change_to)
      this.$store.commit('setCurrentMenu')
      this.$router.replace('/dashboard')
    },
    async sendTrackingAction(starNumber, action, data){
      await imanager3Appframe.sendTrackingAction({
        starNumber: starNumber,
        pluginName: "main",
        uuid: iStoreUtils.generateTrackingUuid(),
        userAction: action,
        data: data
      })
    }
  }
}
</script>
